export const LOADING_BIG_WINS = 'BIG_WINS/LOADING_BIG_WINS';
export const BIG_WINS_LOADED = 'BIG_WINS/BIG_WINS_LOADED';
